<template>
  <v-app :dark="colorScheme.dark" :class="colorScheme.scheme"  >
    <div v-if="show">

      <router-view name="header" />
      <router-view name="sidebar"/>
      <v-content>

         <div
             v-if="isStaging"
             style="width: 100%; z-index: 200; background-color: #ff0000; font-size: 14pt; font-weight: 700; text-align: center; color: white">
            Dev Testing Mode
         </div>

        <router-view />
      </v-content>

      <router-view name="footer" />
    </div>



    <!--<app-settings-->
      <!--:drawer="subDrawer"-->
      <!--@toggleSubDrawer="handleSubdrawer"-->
    <!--&gt;</app-settings>-->
    <!-- Toggle settings button -->
    <!--<v-btn fixed class="settings-btn" @click.stop="subDrawer = !subDrawer">-->
    <!--<v-icon light>settings</v-icon>-->
    <!--</v-btn>-->
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
// import AppSettings from "@/components/AppSettings";
import appDrawerItems from "@/data/app-drawer-items";
import data_getters from './mixins/data_getters';


export default {
   mixins: [data_getters],
  data() {
    return {
       show: false,
       appDrawerItems: appDrawerItems,
      subDrawer: false,
    };
  },
  computed: {
    ...mapGetters({
      colorScheme: "colorScheme",
    }),
     app_name(){
        return this.$store.state.AppName;
     },

     isStaging(){
       return process.env.VUE_APP_NODE_ENV2==='staging';
     }

  },
  methods: {

     // handleSubdrawer(value) {
     //   this.subDrawer = value;
     // }


     // registered in plugins/auth.js
     async update_settings() {

        if (this.$auth.isAuthenticated){


           console.log('i am authenticated');
           // set app colors based on agency
           let agency = await this.get_agencies();
           console.log(agency)

           this.$store.commit('setAppName', agency.app_settings.AppName);
           this.$store.commit('setAgencyLogo', '/static/' + agency.app_settings.AgencyLogo);
           this.$store.commit('setAgencyIcon', agency.app_settings.AgencyIcon);

           this.$store.dispatch("setColorScheme", agency.app_settings.ColorScheme);
           this.$store.dispatch("setNavDrawerScheme", agency.app_settings.DrawerScheme.navDrawerScheme);
           this.$store.dispatch("setNavToolbarScheme", agency.app_settings.DrawerScheme.navToolbarScheme);

           this.$vuetify.theme.primary = agency.app_settings.ColorScheme.secondary;
           this.$vuetify.theme.secondary = agency.app_settings.ColorScheme.secondary;
           this.$vuetify.theme.accent = agency.app_settings.ColorScheme.secondary;

           // push user back to original url once logged in
           // this.$router.push(data.state.target || "/");

           document.title = agency.app_settings.AppName;

           let link = document.querySelector("link[rel*='icon']"); // || document.createElement('link');
           link.type = 'image/x-icon';
           link.rel = 'shortcut icon';
           link.href = agency.app_settings.AgencyIcon;

           console.log('auth callback ran')

           this.show = true;
        }
        else{
           console.log('i am not authenticated')
        }

     }
  },

   async created(){


      this.$auth.$watch("loading", loading => {
         if (loading === false) {
            this.update_settings();
         }
      });

      setTimeout(()=>{
         this.show = true
      }, 5000)

      //

     // document.title = this.app_name;
     //
     //  let link = document.querySelector("link[rel*='icon']"); // || document.createElement('link');
     //  link.type = 'image/x-icon';
     //  link.rel = 'shortcut icon';
     //  link.href = this.$store.state.AppIcon;

   }
};
</script>


<style>

 .hr{
     width: 100%;
     border-top: 1px solid #ababab;
 }
</style>